export default "__VITE_ASSET__BWbPhPJI__"